// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-select[data-v-e463cb62] {\n  max-width: 466px;\n}\n", ""]);
// Exports
module.exports = exports;
